export default {
    path: '/',
    redirect: '/login',
}